module.exports = __webpack_public_path__ + "img/about.8fd101d5.svg";